import React from 'react';
let supervisor = require('react-supervisor');
import RichText from './components/RichText';

supervisor.ReactSupervisor.registerComponent(".rc-rich-text", RichText)
supervisor.ReactSupervisor.initialize();
// supervisor.ReactSupervisor.forceRender(); // will force a DOM scan, it's helpful with dynamically created nodes
